"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureReportType = exports.MeasureErrorType = void 0;
var MeasureErrorType;
(function (MeasureErrorType) {
    MeasureErrorType["MISSING_ELM"] = "MISSING_ELM";
    MeasureErrorType["ERRORS_ELM_JSON"] = "ERRORS_ELM_JSON";
    MeasureErrorType["MISMATCH_CQL_POPULATION_RETURN_TYPES"] = "MISMATCH_CQL_POPULATION_RETURN_TYPES";
    MeasureErrorType["MISMATCH_CQL_RISK_ADJUSTMENT"] = "MISMATCH_CQL_RISK_ADJUSTMENT";
    MeasureErrorType["MISMATCH_CQL_SUPPLEMENTAL_DATA"] = "MISMATCH_CQL_SUPPLEMENTAL_DATA";
})(MeasureErrorType = exports.MeasureErrorType || (exports.MeasureErrorType = {}));
var MeasureReportType;
(function (MeasureReportType) {
    MeasureReportType["INDIVIDUAL"] = "Individual";
    MeasureReportType["SUBJECT_LIST"] = "Subject List";
    MeasureReportType["SUMMARY"] = "Summary";
    MeasureReportType["DATA_COLLECTION"] = "Data Collection";
})(MeasureReportType = exports.MeasureReportType || (exports.MeasureReportType = {}));
